<template>
    <v-layout row xs12 >
        <Loading :value="loading" ></Loading>
        <v-dialog
                v-model="dialogAjoutConducteur"
                max-width="100%">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Ajouter des conducteurs </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout row>
                        <v-flex xs12>
                            <data-tables :data="listeConducteur" style="width: 100%">
                                <el-table-column prop="nom" label="Nom" width="300">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.nom}}
                                        </v-chip>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="prenom" label="Prenom" width="300">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.prenom}}
                                        </v-chip>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="dateNaissance" label="Date de naissance" width="200">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.dateNaissance}}
                                        </v-chip>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="adresse" label="Adresse" width="300">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.adresse}}
                                        </v-chip>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="fonction" label="Fonction" width="200">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.fonction}}
                                        </v-chip>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="tel1" label="telephone 1" width="200">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.tel1}}
                                        </v-chip>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="tel2" label="telephone 1" width="200">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.tel2}}
                                        </v-chip>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="email" label="Email" width="200">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.email}}
                                        </v-chip>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="matricule" label="matricule" width="200">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.matricule}}
                                        </v-chip>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="dateEmbauche" label="date embauche" width="200">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.dateEmbauche}}
                                        </v-chip>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="typePermis" label="type de permis" width="200">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.typePermis}}
                                        </v-chip>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="numPermis" label="numero de permis" width="200">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.numPermis}}
                                        </v-chip>
                                    </template>
                                </el-table-column>

                                <el-table-column prop="dateValidite" label="date de validite" width="200">
                                    <template slot-scope="scope">
                                        <v-chip label text-color="white" color="primary">
                                            {{scope.row.dateValidite}}
                                        </v-chip>
                                    </template>
                                </el-table-column>
                            </data-tables>
                        </v-flex>
                    </v-layout>

                    <v-layout row>
                        <v-flex xs6>
                            <v-tooltip top>
                                <v-btn @click="closeDialog()" color="orange" dark>Anuller <v-icon right>remove_circle</v-icon></v-btn>
                                <!-- <v-btn slot="activator" icons block  @click="closeDialog()" dark>Anuller <v-icon right>remove_circle</v-icon></v-btn> -->
                                <span>Annuler</span>
                            </v-tooltip>
                        </v-flex>

                        <v-flex xs6>
                            <v-tooltip top>
                                <v-btn slot="activator" icons block color="green" @click="saveListe()" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                                <span>Enregistrer les conducteur</span>
                            </v-tooltip>
                        </v-flex>

                    </v-layout>

                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import Loading from '@/components/Loading';
    export default {
        name: "LoadConducteurExcel",
        components: {Loading},
        props:{
            listeConducteur:
            {
                type: Array,
                default: null,
            },
            show:{
                type: Boolean,
                default: false
            }
        },
        data(){
            return {
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

                dialogAjoutConducteur: false,
                loading: false
            }
        },
        watch:{
            show: function(newValue,oldValue){
                if(newValue == true){
                    this.dialogAjoutConducteur =true;
                    console.log("listeConducteur", this.listeConducteur)
                }else{
                    this.dialogAjoutConducteur =false;
                }

            }
        },
        methods: {
            saveListe(){
                this.loading = true;
                let succesEnreg = true;
                let url = this.domaine + "parc/save/liste_conducteur/excel";
                let nbData = 1;
                if(this.listeConducteur.length >10){
                    nbData = 10;
                }
                let nbReq = Math.round(this.listeConducteur.length / nbData);
                let nbRest = this.listeConducteur.length % nbData;
                if(nbRest >0){
                    nbReq += 1;
                }
                console.log("nb requete",nbReq )
                for(let i=0; i<nbReq;i++)
                {
                    let initJ = i*nbData;
                    let finJ = (i+1)*nbData;
                    let dataLot = [];
                    if(this.listeConducteur.length > 0){
                        for(let j = initJ;j < finJ;j++){
                            if(this.listeConducteur[j] == undefined){
                                break ;
                            }
                            dataLot.push(this.listeConducteur[j]);
                        }
                    }
                    console.log("dataLots =", dataLot)
                    let data = new FormData();
                    data.append('listeConducteur', JSON.stringify(dataLot))

                    this.$http.post(url, data).then(
                        resp => {
                        },
                        error => {
                            this.loading = false;
                            this.$message.error(
                                "Erreur lors de l'enregistrement des conducteurs"
                            );
                            succesEnreg = false;

                        }
                    )
                }
                this.loading = false;

                if(succesEnreg == true){
                    this.$notify({
                        title: "Enregistrement",
                        message: "La liste a ete enregistre avec succes",
                        type: "success",
                        position: "top-right",
                        duration: 7000
                    });
                    this.closeDialog()
                }


            },
            closeDialog(){
                //this.dialogAjoutFournisseur = false;
                this.$emit("close")
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/parc/loadConducteur.vue